import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = (props) => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true} style={{zIndex:2}}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Karak Mqanes</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block float-right">
                Powered by{" "}
                <a href="https://mhsinfotech.com" target="_blank">
                  MHS INFOTECH
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
